/**
 * OverviewTabContent
 * Overview tab showing recent updates, next steps, blockers, and fix guidance
 */

import { ClockRegular, ArrowCircleRightRegular } from '@fluentui/react-icons'
import type { IssueDetails } from '../../../../domain'
import { InfoPanel, FixGuidancePanel } from '../panels'
import { BlockersTwoColumn } from '../BlockersTwoColumn'
import { TabContentLayout } from '../shared'

export interface OverviewTabContentProps {
  issue: IssueDetails
}

export function OverviewTabContent({ issue }: OverviewTabContentProps) {
  // Get recent updates from insight sections or use provided field
  const recentUpdates = issue.recentUpdates || []

  // Get next steps from insight sections or use provided field
  const nextSteps = issue.nextSteps || []

  // Check if we have blockers to show
  const hasBlockers =
    (issue.blockers && issue.blockers.length > 0) ||
    (issue.unblockers && issue.unblockers.length > 0)

  // Get fix guidance links
  const fixGuidanceLinks = issue.fixGuidanceLinks || []

  return (
    <TabContentLayout>
      {recentUpdates.length > 0 && (
        <InfoPanel
          title="Recent Updates"
          icon={<ClockRegular />}
          items={recentUpdates}
          emptyMessage="No recent updates"
        />
      )}

      {nextSteps.length > 0 && (
        <InfoPanel
          title="Next Steps"
          icon={<ArrowCircleRightRegular />}
          items={nextSteps}
          emptyMessage="No next steps available"
        />
      )}

      {hasBlockers && (
        <BlockersTwoColumn
          blockers={issue.blockers || []}
          unblockers={issue.unblockers || []}
        />
      )}

      {fixGuidanceLinks.length > 0 && <FixGuidancePanel links={fixGuidanceLinks} />}
    </TabContentLayout>
  )
}
